const webpReg = new RegExp(/\.webp$/);
export const processWebp = (url = ''): string => url.replace(webpReg, '.jpg');
const forceJPGReg = new RegExp(/\.\w+$/);
export const forceJPG = (url: string): string => `${url.replace(forceJPGReg, '')}.jpg`;

export function getImageUrl(uri: string, type = 'large', useWebp = true): string {
  let _uri = uri;
  if (!_uri) {
    return _uri;
  }

  if (/^(http:|https:){0,1}\/\//.test(_uri)) {
    return _uri;
  }

  if (!_uri.includes('tos') && !_uri.includes('pgc')) {
    _uri = `tos-maliva-p-0000/${_uri}`;
  }

  _uri = `//p16-va.topbuzzcdn.com/${type}/${_uri}`;

  if (!useWebp) {
    _uri = processWebp(_uri);
  }
  // va cdn没有跨域头，先用sg的地址，记得改回来
  return _uri;
}
